<template>
  <section class="hero-banner">
    <div class="container">
      <BRow class="content-wrapper">
        <BCol cols="12" lg="7" class="hero-content">
          <h1 class="fw-bold text-white mb-4">
            {{ content.title }}
          </h1>

          <p class="text-white mb-4">
            {{ content.description }}
          </p>
        </BCol>

        <BCol cols="12" lg="5" class="img-wrapper text-center text-lg-end">
          <img
            src="@/esf_venlo_base/assets/images/homeImage1.png"
            :alt="$t('banner.desktop.imageAlt')"
            class="hero-image"
          />
        </BCol>
      </BRow>
    </div>
  </section>
</template>

<script setup>
import { useStore } from "vuex";
import { computed } from "vue";

const store = useStore();

const content = computed(() => {
  const { content } = store.getters[`cmsBlock/getCmsBlockByIdentifier`]("banner");
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");

  const contentObject = {
    title: doc.querySelector("h1")?.textContent.trim() || "",
    description: doc.querySelector("p")?.textContent.trim() || "",
  };

  return contentObject;
});
</script>
